const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedPlayer: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const players = (state = initialState, action) => {
	switch (action.type) {
		case 'PLAYER_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'PLAYER_DEL_DATA':
			const data = state.data.filter((e) => e.id !== action.index)
			return { ...state, data, total: state.total - 1 }
		case 'PLAYER_ADD_DATA':
			const addData = [...state.data, action.data]
			return Object.assign({ ...state, data: addData, total: state.total + 1 })
		case 'PLAYER_UPDATE_DATA':
			const index = state.data.findIndex((e) => e.id === action.index)
			const upateData = state.data
			upateData[index] = action.data
			return Object.assign({ ...state, data: [...upateData] })
		case 'PLAYER_GET_CURRENT':
			return { ...state, selectedPlayer: action.selectedPlayer }
		case 'PLAYER_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return { ...state }
	}
}

export default players
